import { render, staticRenderFns } from "./PageRightProtection.vue?vue&type=template&id=35998475&scoped=true"
import script from "./PageRightProtection.vue?vue&type=script&lang=js"
export * from "./PageRightProtection.vue?vue&type=script&lang=js"
import style0 from "./PageRightProtection.vue?vue&type=style&index=0&id=35998475&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35998475",
  null
  
)

export default component.exports